var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center w-full h-full"},[(!this.params.data.actionData.toggle)?_c('span',{staticClass:"cstm_badge danger",staticStyle:{"font-size":"12px"}},[_vm._v("Inactive")]):_c('span',{staticClass:"cstm_badge success",staticStyle:{"font-size":"12px"}},[_vm._v("Active")])])
}
var staticRenderFns = []

export { render, staticRenderFns }